import React from 'react';
import './Hero.css'; // Nous allons mettre à jour ce fichier

function Hero() {
  // Fonction pour gérer le clic sur les liens internes (CTA, flèche) pour un défilement doux
  const handleScrollDown = (event) => {
    event.preventDefault(); // Empêche le comportement de lien par défaut
    const targetId = event.currentTarget.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Fait défiler la page jusqu'à l'élément cible en douceur
      targetElement.scrollIntoView({
        behavior: 'smooth', // Active le défilement doux
        block: 'start', // Aligne le haut de la cible avec le haut de la zone visible
      });
    }
  };

  return (
    // Section Hero avec l'ID pour la navigation
    <section id="hero" className="hero-section">
      {/* Vidéo en arrière-plan */}
      <video
        autoPlay
        loop
        muted
        playsInline // Important pour la compatibilité mobile
        className="hero-video"
        poster="/images/logo.jpg" // Optionnel: une image de remplacement
      >
        {/* Assurez-vous que la vidéo est dans public/videos/ambrevideo1.mp4 */}
        <source src="/videos/ambrevideo1.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la balise vidéo.
      </video>

      {/* Overlay pour teinter la vidéo et améliorer la lisibilité du texte */}
      <div className="hero-overlay"></div>

      {/* Contenu textuel superposé */}
      <div className="hero-content">
        {/* Titre adapté pour Studio Ambre */}
        <h1 className="hero-title">Studio Ambre</h1>
        {/* Sous-titre adapté pour le salon à Samatan */}
        <p className="hero-subtitle">
          Votre salon de coiffure mixte. Coupes, couleurs, soins personnalisés et conseils experts.
        </p>
        {/* Bouton d'appel à l'action (CTA) adapté */}
        <a
          href="#services" // Pointe vers la section des services
          className="hero-cta-button"
          onClick={handleScrollDown} // Utilise le défilement doux
        >
          Découvrir nos services
        </a>
        {/*
        <a href="URL_PRISE_DE_RDV" target="_blank" rel="noopener noreferrer" className="hero-cta-button secondary">
          Prendre Rendez-vous
        </a>
        */}
      </div>

      {/* Flèche pour faire défiler vers la section suivante ('about') */}
      <a
        href="#about" // Pointe vers la section "À propos"
        className="scroll-down-arrow"
        aria-label="Faire défiler vers le bas"
        onClick={handleScrollDown} // Utilise le défilement doux
      >
        {/* Le contenu visuel de la flèche est géré en CSS */}
      </a>
    </section>
  );
}

export default Hero;